import { listExpenses } from "./api.js";
import { money } from "./format.js";

const DEMO = [
  { id: 1, who: "Priya", what: "Team lunch", cents: 18450 },
  { id: 2, who: "Marco", what: "Conference ticket", cents: 49900 },
  { id: 3, who: "Sam", what: "Taxi to client site", cents: 3275 },
];

function render(rows) {
  const tbody = document.querySelector("#expenses tbody");
  tbody.innerHTML = "";
  for (const r of rows) {
    const tr = document.createElement("tr");
    for (const v of [r.who, r.what, money(r.cents)]) {
      const td = document.createElement("td");
      td.textContent = v;
      tr.appendChild(td);
    }
    tbody.appendChild(tr);
  }
}

listExpenses()
  .then(render)
  .catch(() => {
    document.querySelector("#status").textContent = "API unavailable, showing demo data.";
    render(DEMO);
  });
